/* NOTVIX catalog — search, price filtering, URL state, mobile sheet.

   The need/category taxonomy is NOT handled here any more: both levels are real
   collections, so picking one is a page load and the server does the filtering.
   That matters at 200+ products, where the grid is paginated and anything done
   in JS would only ever see the 48 products on the current page.

   Search and price still run on the client and stay scoped to the current page,
   which is accurate inside a category (well under one page of products) and
   approximate on /collections/all. Sort is server-side via Shopify's ?sort_by;
   this only mirrors it back into the select. */
(function(){
  var grid = document.getElementById('kn-grid');
  if (!grid) return;

  var cards   = Array.prototype.slice.call(grid.querySelectorAll('.kn-card'));
  var qInput  = document.getElementById('kn-q');
  var sortSel = document.getElementById('kn-sort');
  var countEl = document.getElementById('kn-count');
  var emptyEl = document.getElementById('kn-empty');
  var fcount  = document.getElementById('kn-fcount');
  var sheetCount = document.getElementById('kn-sheet-count');

  /* The server renders the collection-wide total into #kn-count. Capture it
     before apply() ever runs: with no client-side filter active the header
     keeps this store-wide number, not the size of the paginated page. */
  var total = countEl ? parseInt(countEl.textContent, 10) : NaN;
  if (isNaN(total) || total < cards.length) total = cards.length;

  var state = { q:'', prices:[] };

  function readURL(){
    var p = new URLSearchParams(location.search);
    state.q      = p.get('q') || '';
    state.prices = (p.get('price') || '').split(',').filter(Boolean);
  }

  function writeURL(){
    var p = new URLSearchParams(location.search);
    state.q ? p.set('q', state.q) : p.delete('q');
    state.prices.length ? p.set('price', state.prices.join(',')) : p.delete('price');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function syncControls(){
    if (qInput && qInput.value !== state.q) qInput.value = state.q;
    document.querySelectorAll('input[data-price]').forEach(function(c){
      c.checked = state.prices.indexOf(c.getAttribute('data-price')) > -1;
    });
    var active = state.prices.length + (state.q ? 1 : 0);
    if (fcount){
      fcount.textContent = active;
      fcount.hidden = active === 0;
    }
  }

  function apply(){
    var q = state.q.trim().toLowerCase();
    var shown = 0;

    cards.forEach(function(card){
      var name  = card.getAttribute('data-name') || '';
      var price = card.getAttribute('data-price') || '';

      var ok = true;
      if (q && name.indexOf(q) === -1) ok = false;
      if (ok && state.prices.length && state.prices.indexOf(price) === -1) ok = false;

      card.hidden = !ok;
      if (ok) shown++;
    });

    /* No filter active → the store-wide total. Filter active → what the
       filter actually matched on this page. */
    var hasFilter = q !== '' || state.prices.length > 0;
    var n = hasFilter ? shown : total;
    if (countEl) countEl.textContent = n + ' product' + (n === 1 ? '' : 's');
    if (sheetCount) sheetCount.textContent = n;
    if (emptyEl) emptyEl.classList.toggle('is-on', shown === 0);
    grid.hidden = shown === 0;

    syncControls();
    writeURL();
  }

  /* Delegated, so the rail and the mobile sheet share one handler. The rail's
     "clear" is an <a> back to /collections/all once a need is open — only the
     root-level <button> version reaches this. */
  document.addEventListener('click', function(e){
    if (e.target.closest('button.kn-clear') || e.target.closest('.kn-clear-all')){
      state = { q:'', prices:[] };
      apply();
    }
  });

  document.addEventListener('change', function(e){
    var pr = e.target.closest('input[data-price]');
    if (pr){
      var pv = pr.getAttribute('data-price');
      state.prices = pr.checked ? state.prices.concat([pv]) : state.prices.filter(function(x){ return x !== pv; });
      apply();
    }
  });

  if (qInput){
    var t;
    qInput.addEventListener('input', function(){
      clearTimeout(t);
      t = setTimeout(function(){ state.q = qInput.value; apply(); }, 180);
    });
  }

  if (sortSel){
    sortSel.addEventListener('change', function(){
      var p = new URLSearchParams(location.search);
      sortSel.value ? p.set('sort_by', sortSel.value) : p.delete('sort_by');
      var qs = p.toString();
      location.assign(location.pathname + (qs ? '?' + qs : ''));
    });
  }

  /* mobile filter sheet */
  var openBtn  = document.getElementById('kn-filter-open');
  var sheet    = document.getElementById('kn-sheet');
  var scrim    = document.getElementById('kn-scrim');
  var closeBtn = document.getElementById('kn-sheet-close');
  var applyBtn = document.getElementById('kn-sheet-apply');
  var lastFocus = null;

  function openSheet(){
    lastFocus = document.activeElement;
    sheet.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function(){
      sheet.classList.add('is-on'); scrim.classList.add('is-on');
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeSheet(){
    sheet.classList.remove('is-on'); scrim.classList.remove('is-on');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function(){ sheet.hidden = true; scrim.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }
  if (openBtn)  openBtn.addEventListener('click', openSheet);
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);
  if (scrim)    scrim.addEventListener('click', closeSheet);
  if (applyBtn) applyBtn.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  readURL();
  apply();
})();